// @flow
import segmentize from './segmentize';

export const formatRent = (rent: ?number) => {
    if (rent && rent > 0) {
        return `£${parseInt(rent, 10).toLocaleString()}`;
    }

    return 'Not specified';
};

export const formatSize = (sqft: ?number, showSqM: ?boolean) => {
    if (sqft && sqft > 0) {
        const sqm = sqft * 0.092903;
        const sqmText = showSqM
            ? ` (${parseInt(sqm, 10).toLocaleString()} sq m)`
            : '';

        return `${parseInt(sqft, 10).toLocaleString()} sq ft ${sqmText}`;
    }

    return 'Not specified';
};

export const getFormValue = (formValues: any, key: string): ?any => {
    const formValue = formValues && formValues[key] ? formValues[key] : null;

    if (typeof formValue === 'string' && formValue.length === 0) {
        return null;
    }

    return formValue;
};

export const getFormAssetId = (formValues: any, key: string): ?string => {
    const formValue = formValues && formValues[key] ? formValues[key] : null;

    if (formValue && formValue.assetId && formValue.assetId.length > 0) {
        return formValue.assetId;
    }

    return null;
};

export function testLocalStorage() {
    try {
        // Test webstorage existence.
        if (!window.localStorage) {
            throw new Error('Local storage not defined.');
        }
        // Test webstorage accessibility - Needed for Safari private browsing.
        localStorage.setItem('storage_test', '1');
        localStorage.removeItem('storage_test');
        return true;
    } catch (e) {
        return false;
    }
}

export function getAuthToken() {
    const hasLocalStorage = testLocalStorage();

    if (!hasLocalStorage) {
        return false;
    }

    return localStorage.getItem('NR_U_TOKEN');
}

export function setAuthToken(token: string) {
    const hasLocalStorage = testLocalStorage();

    if (!hasLocalStorage) {
        return false;
    }

    localStorage.setItem('NR_U_TOKEN', token);
    return true;
}

export const defaultPaginationData = {
    pagination: {
        showing: 0,
        total: 0,
        page: 0,
        pageCount: 0,
        previousPage: 0,
        nextPage: 0,
    },
    order: {
        by: null,
        dir: null,
    },
};

export function getPaginationAndOrderData(data: any) {
    if (!data) {
        return defaultPaginationData;
    }

    const previousPage = data.page > 1 ? data.page - 1 : data.page;
    const nextPage = data.page < data.pageCount ? data.page + 1 : data.page;

    const segments = segmentize({
        page: data.page,
        pages: data.pageCount,
        beginPages: 0, // optional
        endPages: 0, // optional
        sidePages: 3, // defaults to zero
    });

    return {
        pagination: {
            showing: data.count,
            total: data.totalCount,
            page: data.page,
            pageCount: data.pageCount,
            previousPage,
            nextPage,
            segments,
        },
        order: {
            by: data.order ? data.order.by : null,
            dir: data.order ? data.order.dir : null,
        },
    };
}



// WEBPACK FOOTER //
// ./src/shared/utils.js